import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Stepper } from "../../shared/components/stepper/stepper";
import { Step1ApplicantDetails } from "./step1-applicant-details/step1-applicant-details";
import { Step2CompanyDetails } from "./step2-company-details/step2-company-details";
import { Step3BusinessProfile } from "./step3-business-profile/step3-business-profile";
import { Header } from '../../core/services/header';
@Component({
  selector: 'app-onboarding',
  imports: [Stepper, CommonModule, Step1ApplicantDetails, Step2CompanyDetails, Step3BusinessProfile],
  templateUrl: './onboarding.html',
  styleUrl: './onboarding.css'
})
export class Onboarding implements OnInit, OnDestroy {
  onboardingStep: number = 1; //total 4 steps.
  onboardingSubStep: number = 1;

  steps = [
    { label: 'BUSINESS_ONBOARDING.APPLICANT_DETAILS' },
    {
      label: 'BUSINESS_ONBOARDING.COMPANY_DETAILS',
      subSteps: [
        { label: 'BUSINESS_ONBOARDING.COMPANY_REGISTRATION' },
        { label: 'BUSINESS_ONBOARDING.TRADE_LICENSE_DETAILS' },
        { label: 'BUSINESS_ONBOARDING.COMPANY_INFORMATION' }
      ]
    },
    {
      label: 'BUSINESS_ONBOARDING.BUSINESS_PROFILE',
      subSteps: [
        { label: 'BUSINESS_ONBOARDING.BUSINESS_ACTIVITY' },
        { label: 'BUSINESS_ONBOARDING.BUSINESS_ADDRESS' },
        { label: 'BUSINESS_ONBOARDING.KEY_PERSONNEL_DETAILS' }
      ]
    },
    { label: 'BUSINESS_ONBOARDING.SUBMISSION' }
  ];

  // onboarding forms data
  onboardingForm: any = {
    applicant: {},
    company: {},
    profile: {},
  };

  constructor(private headerService: Header) {
  }

  ngOnInit(): void {
    this.loadExistingData();
    this.headerService.updateConfig({
      showNotifications: false,
      showRightSection: false
    });
  }

  ngOnDestroy() {
    this.headerService.resetConfig();
  }

  loadExistingData() {
    // Call API here once, populate `formData`
  }

  nextStep() {
    const currentStepData = this.steps[this.onboardingStep - 1];
    const subSteps = currentStepData.subSteps ?? [];
    const totalSubSteps = subSteps.length;

    // Case 1: Step has substeps
    if (totalSubSteps > 0) {
      // If not on last substep → go to next substep
      if (this.onboardingSubStep < totalSubSteps) {
        this.onboardingSubStep++;
      } else {
        // On last substep → go to next main step
        if (this.onboardingStep < this.steps.length) {
          this.onboardingStep++;
          const nextStepData = this.steps[this.onboardingStep - 1];
          const nextHasSubsteps = (nextStepData.subSteps?.length ?? 0) > 0;
          this.onboardingSubStep = nextHasSubsteps ? 1 : 1; // always 1
        }
      }
    }
    // Case 2: Step has no substeps
    else if (this.onboardingStep < this.steps.length) {
      this.onboardingStep++;
      const nextStepData = this.steps[this.onboardingStep - 1];
      const nextHasSubsteps = (nextStepData.subSteps?.length ?? 0) > 0;
      this.onboardingSubStep = nextHasSubsteps ? 1 : 1;
    }

    //scroll to top
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  prevStep() {
    const currentStepData = this.steps[this.onboardingStep - 1];
    const subSteps = currentStepData.subSteps ?? [];
    const totalSubSteps = subSteps.length;

    // Case 1: On substep > 1 → go to previous substep
    if (totalSubSteps > 0 && this.onboardingSubStep > 1) {
      this.onboardingSubStep--;
    }
    // Case 2: On first substep → go to previous main step
    else if (totalSubSteps > 0 && this.onboardingSubStep === 1) {
      if (this.onboardingStep > 1) {
        this.onboardingStep--;
        const prevStepData = this.steps[this.onboardingStep - 1];
        const prevHasSubsteps = (prevStepData.subSteps?.length ?? 0) > 0;
        this.onboardingSubStep = prevHasSubsteps ? prevStepData.subSteps!.length : 1;
      }
    }
    // Case 3: On main step (no substeps) → go to previous main step
    else if (this.onboardingStep > 1) {
      this.onboardingStep--;
      const prevStepData = this.steps[this.onboardingStep - 1];
      const prevHasSubsteps = (prevStepData.subSteps?.length ?? 0) > 0;
      this.onboardingSubStep = prevHasSubsteps ? prevStepData.subSteps!.length : 1;
    }

  }

  updateFormData(section: string, data: any) {
    this.onboardingForm[section] = { ...this.onboardingForm[section], ...data };
  }

}